/* eslint-disable */
import React, { FC } from 'react';
import { useLottie } from 'lottie-react';

import './loaderLight.scss';

interface ILoaderLight {
  loaderStyle: string;
  loaderData: any;
}

const LoaderLight: FC<ILoaderLight> = ({ loaderStyle, loaderData }) => {
  const options = {
    animationData: loaderData,
    loop: true,
    autoplay: true,
  };

  const { View } = useLottie(options);

  return <div className={loaderStyle}>{View}</div>;
};

export default LoaderLight;
